'use client';

import { Dropdown as HeroDropdown } from '@heroui/react';
import { ReactNode } from 'react';

export interface DropdownProps {
  children: ReactNode;
  onOpenChange?: (isOpen: boolean) => void;
}

const DropdownRoot = ({ children, onOpenChange }: DropdownProps) => {
  return <HeroDropdown onOpenChange={onOpenChange}>{children}</HeroDropdown>;
};

const Trigger = ({ children }: { children: ReactNode }) => (
  <HeroDropdown.Trigger>{children}</HeroDropdown.Trigger>
);

const Popover = ({
  children,
  placement,
  className,
}: {
  children: ReactNode;
  placement?: any;
  className?: string;
}) => (
  <HeroDropdown.Popover placement={placement} className={className}>
    {children}
  </HeroDropdown.Popover>
);

const Menu = ({
  children,
  'aria-label': ariaLabel,
  onAction,
  disabledKeys,
  className,
}: {
  children: ReactNode;
  'aria-label'?: string;
  onAction?: (key: any) => void;
  disabledKeys?: string[];
  className?: string;
}) => (
  <HeroDropdown.Menu
    aria-label={ariaLabel}
    onAction={onAction}
    disabledKeys={disabledKeys}
    className={className}
  >
    {children}
  </HeroDropdown.Menu>
);

const Item = ({
  id,
  children,
  onPress,
  variant,
  textValue,
  className,
}: {
  id?: string;
  children: ReactNode;
  onPress?: () => void;
  variant?: 'default' | 'danger';
  textValue?: string;
  className?: string;
}) => (
  <HeroDropdown.Item
    id={id}
    onPress={onPress}
    variant={variant}
    textValue={textValue}
    className={className}
  >
    {children}
  </HeroDropdown.Item>
);

export const Dropdown = Object.assign(DropdownRoot, {
  Trigger,
  Popover,
  Menu,
  Item,
});
